import { Link } from "react-router-dom";
import { categories, siteEmail, siteName, siteSlogan } from "@/mocks/guawa";

export default function Footer() {
  const now = new Date().getFullYear();

  return (
    <footer className="bg-ink-800 text-cream-100">
      <div className="mx-auto w-full px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {/* 品牌 */}
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-white">
                <i className="ri-water-flash-fill text-xl"></i>
              </span>
              <span className="text-base font-extrabold tracking-tight text-white">{siteName}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-cream-200/80">
              {siteSlogan}。聚合热点事件围观现场，倡导理性、文明、友善的讨论氛围。
            </p>
            <div className="mt-5 flex gap-3">
              {["ri-weibo-line", "ri-wechat-2-line", "ri-bilibili-line", "ri-douban-line"].map((ic) => (
                <a
                  key={ic}
                  href="#site-footer"
                  rel="nofollow noopener"
                  aria-label="社交平台入口"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-ink-700 text-cream-100 transition-colors hover:bg-primary-500"
                >
                  <i className={`${ic} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* 栏目 */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wide text-cream-200">热议栏目</h3>
            <ul className="mt-4 grid grid-cols-2 gap-2 text-sm">
              {categories.map((c) => (
                <li key={c.id}>
                  <Link to="/topics" className="text-cream-200/80 transition-colors hover:text-primary-300 whitespace-nowrap">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 站内 */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wide text-cream-200">站内导航</h3>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm">
              {[
                { to: "/", label: "首页" },
                { to: "/topics", label: "热议专区" },
                { to: "/topic/discuss-2026", label: "本期讨论现场" },
                { to: "/about", label: "关于我们" },
                { to: "/contact", label: "投稿与联系" },
              ].map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-cream-200/80 transition-colors hover:text-primary-300 whitespace-nowrap">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 互动守则 */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wide text-cream-200">互动守则</h3>
            <p className="mt-4 text-sm leading-relaxed text-cream-200/70">
              理性围观、尊重事实、友善表达。请勿发布不实信息或侵犯他人隐私的内容。转载需注明来源。
            </p>
            <a
              href={`mailto:${siteEmail}`}
              className="mt-4 inline-flex items-center gap-2 rounded-full border border-cream-200/30 px-4 py-2 text-sm text-cream-100 transition-colors hover:border-primary-400 hover:text-primary-300 whitespace-nowrap"
            >
              <i className="ri-mail-send-line"></i> {siteEmail}
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-cream-100/10 pt-6 text-xs text-cream-200/60 sm:flex-row">
          <p>© {now} {siteName} · 理性吃瓜，文明讨论。</p>
          <p className="flex items-center gap-2 whitespace-nowrap">
            <i className="ri-flag-2-line"></i> 本社区内容以公开现象与观点讨论为主
          </p>
        </div>
      </div>
    </footer>
  );
}